<script>
export default {
  name: "ArticleFooter",
  props: {
    dictionaryName: {
      type: String,
      required: true
    }
  }
};
</script>

<template>
  <footer class="article-footer">
    <div class="article-footer__dictionary">
      <div class="article-footer__dictionary-title">
        {{ dictionaryName }}
      </div>
    </div>
  </footer>
</template>
